<template>
  <div class="card-container">
    <div class="bg">
      <div class="title">
        {{ title }}
        <!-- <div class="line"></div> -->
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    containerWidth: {
      type: String,
      default: "500",
    },
    title: {
      type: String,
      default: "输入标题",
    },
    containerHeight: {
      type: String,
      default: "500",
    },
  },
};
</script>
<style scoped>
.card-container {
  width: 100%;
  height: 100%;
  margin-bottom: 30px;

}
.bg{
  width: 100%;
  height: 100%;
  background: url('../../assets/images2/bg2.png') no-repeat;
  background-size: 100% 100%;
}
.title {
  padding-top: 30px;
  padding-left: 30px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: blanchedalmond;
  background: linear-gradient(0deg, #76c0ff 0%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.line {
  margin-top: 12px;
  width: 47px;
  height: 2px;
  background: #4cadff;
}
.content {
  /* margin-top: 30px; */
  padding: 0 30px;
}
</style>
